export const booleanSchema = (defaultValue: boolean) => ({
    regNumber: defaultValue,
    modelNumber: defaultValue,
    capacity: defaultValue,
    volume: {
      l: defaultValue,
      b: defaultValue,
      h: defaultValue,
    },
    fleetType: defaultValue,
    bodyType: defaultValue,
    fuelType: defaultValue,
    idealFuel: defaultValue,
    distanceCovered: defaultValue,
    ownerShip: defaultValue,
  });